export const REFERENCES_MOBILE_MEDIA_QUERY = '(max-width: 1100px)'

export type ReferenceSlideDirection = 'next' | 'prev'

export const getIsMobileViewport = () =>
	typeof window !== 'undefined' && window.matchMedia(REFERENCES_MOBILE_MEDIA_QUERY).matches

export const getSlideDirection = (
	fromIndex: number,
	toIndex: number,
	total: number,
	loop: boolean
): ReferenceSlideDirection => {
	if (fromIndex === toIndex) return 'next'

	if (!loop || total <= 1) {
		return toIndex > fromIndex ? 'next' : 'prev'
	}

	const forward = (toIndex - fromIndex + total) % total
	const backward = (fromIndex - toIndex + total) % total

	return forward <= backward ? 'next' : 'prev'
}
